import React, { useEffect } from 'react';
import { useNavigate } from "react-router";
import { getStateLoaded, getReportDoc } from 'store/store';
import { getEleArray } from 'helpers/Helpers';
import ApplicantInformation from "./ApplicantInformation";
import RiskScores from "./RiskScores";
import Tradelines from "./Tradelines";
import PublicRecords from "./PublicRecords";
import Inquiries from "./Inquiries";
import SSNCheck from './SSNCheck';
import Variations from './Variations';
import CreditorContact from './CreditorContact';
import Spinner from 'components/spinner/Spinner';

export default function Report() {
  var loaded = getStateLoaded();
	let navigate = useNavigate();
	console.log("Report", loaded);

	useEffect(() => {
		if (!loaded) {
			navigate('/');
		};

	},[]);

	if (!loaded) return (<Spinner />)
	// display XML

	var reportDoc = getReportDoc();
	var cr = reportDoc.RESPONSE_GROUP.RESPONSE.RESPONSE_DATA.CREDIT_RESPONSE;
	//console.log("cr: ", typeof cr, cr);

	var bors = getEleArray(cr, "BORROWER");
	//console.log("bors: ", typeof bors, bors);
	const scores = getEleArray(cr, "CREDIT_SCORE");
	//console.log("scores: ", typeof scores, scores);
	const trades = cr.CREDIT_LIABILITY;
	//console.log("trades: ", typeof trades, trades);
	const publicrecords = getEleArray(cr, "CREDIT_PUBLIC_RECORD");
	//console.log("publicrecords: ", typeof publicrecords, publicrecords);
	const inquiries = getEleArray(cr, "CREDIT_INQUIRY");
	//console.log("inquiries: ", typeof inquiries, inquiries);
	const creditfiles = getEleArray(cr, "CREDIT_FILE");
	//console.log("creditfiles: ", typeof creditfiles, creditfiles);
	const creditors = cr.CREDIT_TRADE_REFERENCE;

	return (
		<div className='report-container'>
			<div className='flex flex-col justify-center'>
				{/* <div className="text-3xl font-bold text-center">Report for {xmlfilename}</div> */}
				<ApplicantInformation bors={bors}/>
				<RiskScores scores={scores} />
				<Tradelines trades={trades} />
				<PublicRecords publicrecords={publicrecords} />
				<Inquiries inquiries={inquiries} />
				<SSNCheck variations={creditfiles} />
				<Variations variations={creditfiles} />
				<CreditorContact creditors={creditors} />
				{/* 
				*/}
			</div>
		</div>
	)
}
